function Header(props) {
  return (
    <section className="page-section section-header">
      <div className="container p-0">
        <div className="d-flex align-items-center message-header">
          <img alt="" className="message-avatar" src={props.operator.avatar} />
          <div className="me-3">
            <div>{props.operator.nickname}</div>
            <div> {props.created_at}</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Header;
